import { Form } from "formik";
import styled from "styled-components";
import {
  accent,
  primary,
  secondary,
  symbol,
  tertiary,
  white
} from "~/components/mixins/color";

export const Container = styled.div`
  height: 100%;
  max-height: ${props => props.maxHeight};
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 10px;

  @media (max-width: 425px) {
    max-height: 100%;
  }
`;

export const TabContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
  padding-top: 0px;

  .empty {
    display: flex;
    justify-content: center;
    width: 100%;
    font-size: 14px;
  }
`;

export const Summary = styled.div`
  display: flex;
  width: 100%;
  height: 40px;
  background-color: #313134;
  align-items: center;

  .label {
    display: flex;
    justify-content: center;
    width: 100%;
    font-size: 14px;
    font-weight: 600;
  }
`;

export const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;
  overflow: hidden;
  height: 100%;
`;

export const Item = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  height: 46px;
  padding: 15px;
  background: ${primary.hex()};
  border: 2px solid ${tertiary.hex()};
  border-radius: 3px;
  color: ${white.hex()};

  &:hover {
    background-color: ${secondary.hex()};
  }

  & > svg {
    color: ${symbol.hex()};
    transition: color 0.2s ease 0s;

    &:hover {
      color: ${accent.hex()};
      cursor: pointer;
    }
  }

  & > .paid {
    color: #53d449;
  }
  & > .late {
    color: #e80000;
  }

  & .column-data {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-right: 30px;

    .first {
      display: flex;
      flex-direction: column;
    }
  }
`;
